export const dropIn = {
  hidden: {
    y: '-10px',
    opacity: 0,
  },
  visible: {
    y: '0',
    opacity: 1,
    transition: {
      type: 'tween',
    },
  },
  exit: {
    y: '-20px',
    opacity: 0,
  },
};
